export default "__VITE_ASSET__401ac4d7__"